import React, { useState, useContext } from "react";
import axios from "axios";
import {
  Button,
  Typography,
  Paper,
  Box,
  Alert,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import AuthContext from "../../contexts/Islogin";

const WithdrawUSDT = () => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const { url } = useContext(AuthContext);

  const handleFetchWallet = async () => {
    setError(null);
    setResponse(null);
    setLoading(true);

    try {
      const token = localStorage.getItem("token");

      const res = await axios.get(
        `${url}api/v1/trons/wallet`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setResponse(res.data);
    } catch (err) {
      console.error(err);
      if (err.response) {
        setError(err.response.data);
      } else {
        setError({ message: "Something went wrong." });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 3, width: '60%', mx: "auto", mt: 5 }}>
      <Typography variant="h6" gutterBottom>
        دریافت کیف پول
      </Typography>

      <Box display="flex" flexDirection="column" gap={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleFetchWallet}
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : "دریافت کیف پول"}
        </Button>

        {response && !error && (
          <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table>
              <TableBody>
                {Object.entries(response).map(([key, value]) => (
                  <TableRow key={key}>
                    <TableCell>{key}</TableCell>
                    <TableCell>{value}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {error && (
          <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
            <Alert severity="error">خطا</Alert>
            <pre
              style={{
                backgroundColor: "#fff0f0",
                padding: "10px",
                borderRadius: "5px",
                maxHeight: "300px",
                overflow: "auto",
                direction: "ltr",
              }}
            >
              {JSON.stringify(error, null, 2)}
            </pre>
          </Paper>
        )}
      </Box>
    </Paper>
  );
};

export default WithdrawUSDT;